import { __utils } from "Utils/Utils";



/**
 * MessageNumber class
 */
export class ConversationID {

    __id = __utils.getRandomIdShort();

    new = () => {
        this.__id = __utils.getRandomIdShort();
    }
    set = (id) => {
        this.__id = id;
    }
    get = () => {
        return this.__id;
    }
    reset = () => {
        this.__id = null;
    }
}
